const state = {
  isShow: false,
  currentModal: ''
}

const mutations = {
  setModal (state, name) {
    state.currentModal = name
  },
  hideModal (state) {
    state.currentModal = ''
  }
}

const getters = {
  getCurrentModal: state => () => state.currentModal,
}

const actions = {
  showModalMain ({ commit }) {
    commit('setModal', 'Personal')
  },
  showModalPlan ({ commit }) {
    commit('setModal', 'Plan')
  },
  showModalPayment ({ commit }) {
    commit('setModal', 'Payment')
  },
  showModalRegistConfirm ({ commit }) {
    commit('setModal', 'RegistConfirm')
	},
	showModalRegistThanks ({ commit }) {
    commit('setModal', 'RegistThanks')
	},

	showModalMypageTop ({ commit }) {
    commit('setModal', 'MypageTop')
	},
	showModalEditThanks ({ commit }) {
    commit('setModal', 'MypageEditThanks')
	},
	showModalEditPlanConfirm ({ commit }) {
    commit('setModal', 'MypageEditPlanConfirm')
	},
	showModalEditPlanThanks ({ commit }) {
    commit('setModal', 'MypageEditPlanThanks')
	},

  showModalContact ({ commit }) {
    commit('setModal', 'Contact')
  },
  showModalContactThanks ({ commit }) {
    commit('setModal', 'ContactThanks')
  },

  showModalSearch ({ commit }) {
    commit('setModal', 'Search')
  },
  showModalLogin ({ commit }) {
    commit('setModal', 'Login')
  },
  showModalLostPassword ({ commit }) {
    commit('setModal', 'LostPassword')
  },
  showModalLostPasswordThanks ({ commit }) {
    commit('setModal', 'LostPasswordThanks')
  },
  showModalMainMenu ({ commit }) {
    commit('setModal', 'MainMenu')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/vue/store/opedModal.js